(function ($) {
  $(document).ready(function() {
    var $button, $dropdown;
    $button = $(".block-language .dropdown-button");
    $dropdown = $(".block-language .dropdown");
    $button.on('click', function(e) {
      if($dropdown.hasClass('show-menu')){
        $dropdown.removeClass('show-menu');
        $button.find('i').addClass('si-chevron-down').removeClass('si-chevron-up');
        $dropdown.off('clickOutside');
      }else{
        $dropdown.addClass('show-menu');
        $button.find('i').addClass('si-chevron-up').removeClass('si-chevron-down');
        $dropdown.on('clickOutside', function () {
          $dropdown.removeClass('show-menu');
          $button.find('i').addClass('si-chevron-down').removeClass('si-chevron-up');
        });
      }
      //e.stopPropagation();
    });
    $dropdown.children("li").on('click', function(event) {
      window.location = $(this).find('a').attr('href');
    });

    $(window).on('resize', function(){
      $dropdown.removeClass('show-menu');
      $button.find('i').addClass('si-chevron-down').removeClass('si-chevron-up');
    });
  });
})(jQuery);
